import { render, staticRenderFns } from "./ServerMonitor.vue?vue&type=template&id=afcd3190&scoped=true"
import script from "./ServerMonitor.vue?vue&type=script&lang=js"
export * from "./ServerMonitor.vue?vue&type=script&lang=js"
import style0 from "./ServerMonitor.vue?vue&type=style&index=0&id=afcd3190&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afcd3190",
  null
  
)

export default component.exports